export enum OtherSensorNameEnum {
  LEAKAGE_1 = 'Leckage 1',
  LEAKAGE_2 = 'Leckage 2',
  LIGHT = 'Licht',
  SHAFT_CONTACT_1 = 'Schachtkontakt 1',
  SHAFT_CONTACT_2 = 'Schachtkontakt 2',
  SWITCHABLE_OUTPUT_1 = 'Schaltbarer Ausgang 1',
  SWITCHABLE_OUTPUT_2 = 'Schaltbarer Ausgang 2'
}
